// plugins/paywall.client.ts
import { vPaywall } from './paywall-directive'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('paywall', vPaywall)
})
